import store from '@/store';
import router from '@/router';

/* eslint-disable no-eq-null */
/* eslint-disable eqeqeq */

function wasResponseCancelled(response) {
	return response != null && (response.status <= 0);
}

function createHttpStatusMessage(response) {
	if (response == null) {
		return 'Invalid Response';
	}
	var config = response.config || {};
	return ('HTTP ' + (response.status || 0) + ' ' + response.statusText + ' ' + (config.method || '') + ' ' + (config.url || '')).replace(/\s+$/, '');
}

export default {

	resolveData(response) {
		return (response.status === 204) ? null : response.data;
	},

	rejectData(response) {
		response = response.response || response;

		if (response == null) {
			return Promise.reject(response);
		}
		if (wasResponseCancelled(response)) {
			return Promise.reject(new Error('REQUEST_CANCELED'));
		}
		if (response.message) {
			return Promise.reject(new Error(response.message));
		}
		var isJson = typeof response.data !== 'string' || (response.headers('Content-Type') || '').indexOf('application/json') >= 0,
			data = isJson && (!response.data || typeof response.data === 'string') ? new Error(response.data || createHttpStatusMessage(response)) : response.data;

		return Promise.reject(data.error || data);

	},

	interceptError(error, instance) {
		let originalRequest = error.config;
		const unauthorized = error.response && error.response.data && error.response.data.message && error.response.data.message.toLowerCase() === 'unauthorized';
		// if the error is 401 and hasn't already been retried
		if (error.response.status === 401 && !originalRequest.retry && unauthorized) {
			// now it can be retried
			originalRequest.retry = true;
			const refresh = store.getters.refreshToken;
			return store.dispatch('AUTH_REQUEST', {
				refreshToken: refresh
			})
				.then((response) => {
					// force orginal request to use new access token
					originalRequest.headers['X-IS-AT'] = response.data.accessToken;
					return instance(originalRequest);
				})
				.catch((error) => {
					router.push({path: '/logout', query: { destination: router.currentRoute.path }});
				});
		}

		return Promise.reject(error);

	},

	createListMapper(mapper) {
		return function listMapper(response) {
			if (!response) {
				return [];
			}
			var list = response.data,
				status = response.status || 0;
			if (!Array.isArray(list)) {
				list = (status === 204 || list == null || list === '') ? [] : [list];
			}
			return list.map(mapper);
		};
	}

};



// WEBPACK FOOTER //
// ./src/modules/http.js